import { router } from '@inertiajs/react'
import { ComingSoonBadge } from '@/components/ui/ComingSoonBadge'
import routes from '@/routeHelpers'
import { useRouteParams } from '@/hooks/useRoutes'
import { cn } from '@/lib/utils'
import type { AnalyticsFilters } from '@/types/analytics'

const TABS: { key: AnalyticsFilters['section']; label: string; comingSoon?: boolean }[] = [
  { key: 'overview', label: 'Overview' },
  { key: 'conversations', label: 'Conversations' },
  { key: 'response_time', label: 'Response time' },
  { key: 'agents', label: 'Agents' },
  { key: 'topics', label: 'Topics' },
  { key: 'csat', label: 'CSAT' },
]

interface AnalyticsTabsProps {
  active: AnalyticsFilters['section']
  range: AnalyticsFilters['range']
  inboxId: number | null
}

export function AnalyticsTabs({ active, range, inboxId }: AnalyticsTabsProps) {
  const { withAccount } = useRouteParams()

  const go = (section: AnalyticsFilters['section']) => {
    router.visit(routes.analytics.show.path(withAccount()), {
      data: { section, range, inbox_id: inboxId ?? '' },
      preserveScroll: true,
      preserveState: true,
    })
  }

  return (
    <div role="tablist" className="flex flex-wrap items-center gap-1 border-b">
      {TABS.map((tab) => {
        const isActive = tab.key === active
        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            aria-disabled={tab.comingSoon || undefined}
            disabled={tab.comingSoon}
            onClick={() => !tab.comingSoon && go(tab.key)}
            className={cn(
              'flex items-center gap-2 px-3 py-2 text-sm border-b-2 -mb-px bg-transparent',
              isActive ? 'border-primary font-medium' : 'border-transparent text-muted-foreground',
              tab.comingSoon ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer hover:text-foreground',
            )}
          >
            <span>{tab.label}</span>
            {tab.comingSoon && <ComingSoonBadge />}
          </button>
        )
      })}
    </div>
  )
}
